import React from 'react';
import coin from '../assets/market-r9/kc-coin.png';
export default function CoinIcon({size=30}){return <img className="kc-coin-r9" src={coin} alt="" aria-hidden="true" style={{width:size,height:size,objectFit:'contain',flexShrink:0}}/>;}
